import React from 'react';
import './ProductListHeader.css';

const ProductListHeader = ({ 
  productCount = 0, 
  totalCount = 0,
  isLoading = false 
}) => {
  return (
    <div className="product-list-header">
      <div className="products-count">
        {isLoading ? (
          <span className="count-loading">Loading products...</span>
        ) : (
          <span className="count-text">
            Showing {productCount.toLocaleString()} products
            {totalCount > productCount && (
              <span className="total-count"> of {totalCount.toLocaleString()}</span>
            )}
          </span>
        )}
      </div>
    </div>
  );
};

export default ProductListHeader;
